
const FALLBACK_SUPABASE_URL = "https://ladquxscytpamcpyyayc.supabase.co";
const FALLBACK_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxhZHF1eHNjeXRwYW1jcHl5YXljIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDg2MDY5MjcsImV4cCI6MjA2NDE4MjkyN30.S11dIsVULt-fgnIiQlXWrOM976GiGtCquxHs7wGgdNw";
const FALLBACK_PROJECT_ID = "ladquxscytpamcpyyayc";

/**
 * Warn loudly (once) if VITE_SUPABASE_URL is set but malformed. A wrong URL
 * here makes every request fail with ERR_NAME_NOT_RESOLVED, which is otherwise
 * painful to trace in a deployed build. An unset value is fine — we fall back
 * to production below.
 */
function validateConfiguredUrl(): void {
  const configured = import.meta.env.VITE_SUPABASE_URL;
  if (!configured) return;
  if (!/^https:\/\/[a-z0-9-]+\.supabase\.co\/?$/i.test(configured)) {
    console.error(
      `[supabase] VITE_SUPABASE_URL does not look like a valid Supabase URL: "${configured}". ` +
        `Expected e.g. https://<project-ref>.supabase.co — requests will likely fail.`
    );
  }
}
validateConfiguredUrl();

/** Get the Supabase URL from environment or fallback to production */
export const getSupabaseUrl = (): string =>
  import.meta.env.VITE_SUPABASE_URL || FALLBACK_SUPABASE_URL;

/** Get the Supabase anon key from environment or fallback to production */
export const getAnonKey = (): string =>
  import.meta.env.VITE_SUPABASE_ANON_KEY || FALLBACK_ANON_KEY;

/** Get the Supabase project ID from environment or fallback to production */
export const getProjectId = (): string =>
  import.meta.env.VITE_SUPABASE_PROJECT_ID || FALLBACK_PROJECT_ID;

/** Build a full edge function URL for a given function name */
export const getEdgeFunctionUrl = (functionName: string): string =>
  `${getSupabaseUrl()}/functions/v1/${functionName}`;

/** Get the Supabase dashboard URL for a given path */
export const getSupabaseDashboardUrl = (path: string): string =>
  `https://supabase.com/dashboard/project/${getProjectId()}/${path}`;
